module.exports = __webpack_public_path__ + "static/header-a93c9394e001a7b5740a8457cb4b67d1.jpg";